import { Button } from "atoms/button/Button";
import { Checkbox } from "atoms/checkbox/Checkbox";

import { QuizStepProps } from "../useQuestionnaire";

const options = [
  {
    name: "Pregnant",
    value: "Pregnant",
    label:
      "Currently or possibly pregnant, or atively trying to become pregnant",
  },
  {
    name: "Breastfeeding",
    value: "Breastfeeding",
    label: "Breastfeeding or bottle-feeding with breastmilk",
  },
  {
    name: "KidneyDisease",
    value: "KidneyDisease",
    label: "End-stage kidney disease (on or about to be on dialysis)",
  },
  {
    name: "LiverDisease",
    value: "LiverDisease",
    label: "End-stage liver disease (cirrhosis)",
  },
  {
    name: "EatingDisorder",
    value: "EatingDisorder",
    label: "Current or prior eating disorder",
  },
  {
    name: "SuicidalThoughts",
    value: "SuicidalThoughts",
    label: "Current suicidal thoughts and/or prior suicidal attempt",
  },
  {
    name: "Cancer",
    value: "Cancer",
    label:
      "Cancer (active diagnosis, active treatment, or in remission or cancer-free for less than 5 continuous years; does not apply to non-melanoma skin cancer that was considered cured via simple excision alone)",
  },
  {
    name: "OrganTransplant",
    value: "OrganTransplant",
    label: "History of organ transplant on anti-rejection medication",
  },
  {
    name: "GastrointestinalCondition",
    value: "GastrointestinalCondition",
    label:
      "Severe gastrointestinal condition (gastroparesis, blockage, inflammatory bowel disease)",
  },
  {
    name: "None",
    value: "None",
    label: "None of the above",
  },
];

export const Diagnoses = (props: QuizStepProps) => {
  const hasError =
    props.errors !== null && props.errors.Diagnoses !== undefined;
  const handleCheckChange = (checked: boolean, value: string) => {
    if (!props.data.Diagnoses) {
      props.data.Diagnoses = [];
    }
    if (!checked) {
      const newList = (props.data.Diagnoses as string[]).filter(
        (v: string) => v !== value
      );
      props.handleStepData("Diagnoses", newList);
    } else {
      if (value === "None") {
        props.handleStepData("Diagnoses", ["None"]);
      } else {
        //-- If the user had None checked and selects another option, we need to remove None.
        if (props.data.Diagnoses.includes("None")) {
          const newList = (props.data.Diagnoses as string[]).filter(
            (v: string) => v !== "None"
          );
          props.handleStepData("Diagnoses", [...newList, value]);
        } else {
          props.handleStepData("Diagnoses", [...props.data.Diagnoses, value]);
        }
      }
    }
  };

  const handleNext = () => {
    if (props.next !== undefined) {
      props.next();
    }
  };

  return (
    <div className="flex h-full flex-col">
      <p className="pb-8 font-serif text-h3">
        Do any of the following apply to you?
      </p>
      <div>
        <div className="flex flex-col items-start gap-2">
          {options.map((option) => (
            <div key={option.value} className="w-full">
              <Checkbox
                checked={props.data?.Diagnoses?.includes(option.value)}
                label={option.label}
                onChange={(e) => handleCheckChange(e, option.value)}
                textStyle="text-bold2"
              />
              <div className="w-full border-b border-gray-100 pt-1" />
            </div>
          ))}
        </div>
      </div>
      {hasError && (
        <div className="mt-2">
          <p className="text-sub1 text-red">
            * Plese select one or more options
          </p>
        </div>
      )}
      <div className="mt-auto">
        <Button onClick={handleNext} fullWidth>
          Next Question
        </Button>
      </div>
    </div>
  );
};
